
import React from "react";
import { Button } from "@/components/ui/button";

interface ConversationWrapperProps {
  isLoading: boolean;
  error: string | null;
  canMessage: boolean;
  onBack: () => void;
  onRefresh: () => void;
  children: React.ReactNode;
}

/**
 * Wrapper component that handles conditional rendering of conversation states
 * like errors, permission checks, and loading states
 */
const ConversationWrapper: React.FC<ConversationWrapperProps> = ({
  isLoading,
  error,
  canMessage,
  onBack,
  onRefresh,
  children
}) => {
  // Error state
  if (error) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center p-6">
        <p className="text-red-500 mb-4">{error}</p>
        <Button onClick={onRefresh}>Try Again</Button>
      </div>
    );
  }

  // Permission check
  if (!canMessage) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center p-6">
        <p className="text-amber-500 mb-4">You cannot message this user directly.</p>
        <Button onClick={onBack}>Go Back</Button>
      </div>
    );
  }

  // Return the children with flex-1 to fill available space
  return <div className="flex-1 flex flex-col h-full overflow-hidden">{children}</div>;
};

export default ConversationWrapper;
